import { C_AMBER, rgba } from '../utils/palette';
import { setupCanvas } from '../utils/canvas';

/**
 * Generic line + area distribution chart.
 * @param {HTMLCanvasElement} canvas
 * @param {{ labels: number[], data: number[] }} chartData
 * @param {string} [color]  hex color, defaults to C_AMBER
 */
export function renderYearsSkating(canvas, { labels, data }, color = C_AMBER) {
    if (!canvas || labels.length < 2) return;
    const pad = { top: 16, right: 12, bottom: 24, left: 28 };
    const w   = canvas.parentElement.clientWidth;
    const h   = 130;
    const ctx = setupCanvas(canvas, w, h);
    ctx.clearRect(0, 0, w, h);

    const max = Math.max(...data, 1);
    const iw  = w - pad.left - pad.right;
    const ih  = h - pad.top - pad.bottom;
    const px  = i => pad.left + (i / (labels.length - 1)) * iw;
    const py  = v => pad.top + ih - (v / max) * ih;

    // area fill
    ctx.beginPath();
    labels.forEach((_, i) => i === 0 ? ctx.moveTo(px(i), py(data[i])) : ctx.lineTo(px(i), py(data[i])));
    ctx.lineTo(px(labels.length - 1), pad.top + ih);
    ctx.lineTo(px(0), pad.top + ih);
    ctx.closePath();
    ctx.fillStyle = rgba(color, 0.08);
    ctx.fill();

    // line
    ctx.beginPath();
    labels.forEach((_, i) => i === 0 ? ctx.moveTo(px(i), py(data[i])) : ctx.lineTo(px(i), py(data[i])));
    ctx.strokeStyle = rgba(color, 0.5);
    ctx.lineWidth   = 1.5;
    ctx.lineJoin    = 'round';
    ctx.stroke();

    // dots
    labels.forEach((_, i) => {
        ctx.beginPath();
        ctx.arc(px(i), py(data[i]), 2.5, 0, 2 * Math.PI);
        ctx.fillStyle = rgba(color, 0.6);
        ctx.fill();
    });

    // axis labels
    ctx.fillStyle    = '#a3a3a3';
    ctx.font         = '9px monospace';
    ctx.textAlign    = 'center';
    ctx.textBaseline = 'top';
    const step = Math.max(1, Math.floor(labels.length / 8));
    labels.forEach((label, i) => {
        if (i % step !== 0 && i !== labels.length - 1) return;
        ctx.fillText(label, px(i), h - pad.bottom + 4);
    });
    ctx.textAlign    = 'right';
    ctx.textBaseline = 'middle';
    [max, Math.round(max / 2)].forEach(v => ctx.fillText(v, pad.left - 4, py(v)));
}
